import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modal-order',
  templateUrl: './modal-order.component.html',
  styleUrls: ['./modal-order.component.scss']
})
export class ModalOrderComponent {

  @Output() sendOrder = new EventEmitter<string>();

  public listEmp = [
    {id: 1, desc: 'Mais antigo no início'},
    {id: 2, desc: 'Mais recente no início'},
    {id: 3, desc: 'Empreendimento A-Z'},
    {id: 4, desc: 'Empreendimento Z-A'}
  ];

  public listOrder = [
    {id: 1, desc: 'Endereço A-Z'},
    {id: 2, desc: 'Endereço Z-A'}
  ];

  public send(data: string) {
    return this.sendOrder.emit(data);
  }

}
